import React from 'react'
import './NavBar.css'
import logo from '../../assets/img/motion-logo.png';
import PopOver from '../../UI/PopOver/PopOver';
import { Col, Row, Button } from 'react-bootstrap';
import UserInfo from '../UserInfo/UserInfo';


const NavBar = (props) => {
  const userName = JSON.parse(localStorage.getItem('user')).data.user.name;
  console.log(userName);

  const redirectToQuizMaster = () => {
    // 👉 Get userId (change based on your storage)
    const userId = JSON.parse(localStorage.getItem('user')).data.user.user_id;


    // 👉 Create form
    const form = document.createElement("form");
    form.method = "POST";
    form.action = "https://quizmaster.motion.ac.in/login_confirmation.php";
    form.target = "_self";

    // 👉 Hidden input
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "userId";
    input.value = userId;

    form.appendChild(input);

    // 👉 Append + submit
    document.body.appendChild(form);
    form.submit();
  };

  return (
    <>
      <nav className="upper-nav">
        <div className="sidebar-button">
          <i
            className={`bx sidebarBtn ${props.isActicveClass}`}
            onClick={props.navClickHandler}
          ></i>
          <img src={logo} className="dashboard img-fluid" alt="Motion" />
        </div>

        <div className="profile-noti">


          {/* ✅ BUTTON */}
          <Button variant="warning" className='' onClick={redirectToQuizMaster}>
            Go to Old QuizMaster
          </Button>
          <div className="fw-bold">
            {userName}
          </div>

          <div>
            <PopOver
              triggerBTN={<i className="bx bx-bell"></i>}
              headerName="Notifications"
            >
              <div className="popBody">
                <div className="popBody_inner">
                  <Row>
                    <Col sm={9}>
                      <h5>Paper</h5>
                      <p>Motion is on the high</p>
                    </Col>
                    <Col sm={3}>
                      <p className="text-end">2 min ago</p>
                    </Col>
                  </Row>
                </div>
                <div className="popBody_inner">Motion Education</div>
                <div className="popBody_inner">Notification aa rhi hai</div>
                <div className="popBody_inner">Paper is submitted</div>
              </div>
            </PopOver>
          </div>

          <UserInfo />
          <i className='bx bx-log-out' onClick={props.onLogOut}></i>
        </div>
      </nav>
    </>
  );
}

export default NavBar;